import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";

export default {
  GetDailyReportList(payload) {
    console.log("GetDailyReportList Payload", payload);
    if (payload && payload.hasOwnProperty("OLD") && payload.OLD) {
      return Api().post("/api/admin/v2.1/getdailysalesreports", payload);
    } else if (
      payload &&
      payload.hasOwnProperty("version") &&
      payload.version == "v4"
    ) {
      return Api().post("/api/admin/v4/getdailysalesreports", payload);
    } else {
      return Api().post("/api/admin/v2/getdailysalesreports", payload);
    }
  },
  GetAggregatorDailyReportList(payload) {
    return Api().post("/api/admin/v2/getaggregatordailysalesreports", payload);
  },
  GetScreenWiseCollectionReport(payload) {
    return Api().post("/api/admin/v2/getscreenwisesalesreports", payload);
  },
  GetFilmWiseCollectionReport(payload) {
    return Api().post("/api/admin/v2/getfilmwisesalesreports", payload);
  },
  GetFilmPerformaneTakingReport(payload) {
    return Api().post("/api/admin/v2/filmPerformanceTakingReport", payload);
  },
  GetPerformanceReportList(payload) {
    return Api().post("/api/admin/v2/getperformancereports", payload);
  },
  getPerformanceReportAkil(payload) {
    return Api().post(`/api/admin/v2/getPermofanceReportV3`, payload);
  },
  GetBoxOfficeSummaryReport(payload) {
    const query = createQueryString(payload);
    return Api_2().get(`/api/admin/v2/boxOfficeTransaction${query}`);
  },
  GetBoxOfficeReceiptReport(payload) {
    const query = createQueryString(payload);
    return Api_2().get(`/api/admin/v2/boxOfficeReceipt${query}`);
  },
  GetBoxOfficeReceiptReportV3(payload) {
    const query = createQueryString(payload);
    return Api_2().get(`/api/admin/v3/boxOfficeReceipt${query}`);
  },
  GetFnBComboSalesReport(payload) {
    return Api_2().post(`/api/reports/fnbComboSalesRepot`, payload);
  },
  GetRateCardAnalysisReport(payload) {
    return Api_2().post(`/api/admin/v2/rateCardAnalysis`, payload);
  },
  GetETransactionsReport(payload) {
    return Api().post(`/api/admin/v2/etransactionsreport`, payload);
  },
  GetRefundShowDetail(payload) {
    return Api().post(`/api/admin/v2/refundShowDetails`, payload);
  },
  GetBoxOfficeReceiptSummary(payload) {
    return Api_2().post(`/api/admin/v2/boxOfficeReceiptSummary`, payload);
  },
  GetClosedShiftSingleDay(payload) {
    return Api_2().post(`/api/admin/v2/closedShiftsSingleDay`, payload);
  },
  GetHouseKeepingReport(payload) {
    return Api().post(`api/admin/v2/houseKeepingReport`, payload);
  },
  GetSalesRegisterReport(payload) {
    return Api().post(`api/admin/v2/salesRegisterReport`, payload);
  },
  GetSalesRegisterReportMultiple(payload) {
    return Api().post(`api/admin/v2/salesRegisterReport-multiple`, payload);
  },
  GetOnlineBookingsReport(payload) {
    return Api().post(`api/admin/v2/onlineSalesReport`, payload);
  },
  GetRawMaterialSupplierWise(payload) {
    return Api().post(`api/admin/v2/rawMaterialSupplierWiseReport`, payload);
  },
  GetFnBSalesReport(payload) {
    return Api().post(`api/admin/v2/fnbSalesReport`, payload);
  },
  GetFnBSalesExcel(payload) {
    return Api().post(`api/admin/v2/fnbSalesExcel`, payload);
  },
  GetRdrException(payload) {
    return Api_2().post(`api/admin/v2/rdrExceptionRegister`, payload);
  },
  GetCashierrShiftSummary(payload) {
    return Api_2().post(`api/admin/v2/cashierShiftSummary`, payload);
  },
  GetFnBPartnerSalesReport(payload) {
    return Api().post(`api/admin/v2/fnbAggregatorSalesReport`, payload);
  },
  GetGcamDetailedReport(payload) {
    return Api().post(`api/admin/v2/detailedGcamReport`, payload);
  },
  GetOccupancySummaryReport(payload) {
    return Api().post(`api/admin/v2/occupancySummaryReport`, payload);
  },
  GetAggregatorSalesNew(payload) {
    return Api().post(`api/admin/v2/get-aggregator-sales-report`, payload);
  },
  GetAggregatorSalesNewWithComplimentary(payload) {
    return Api().post(
      `api/admin/v2/get-aggregator-sales-report-with-complimentary`,
      payload
    );
  },
  GetdailySalesRecordsConcessionV2(payload) {
    if (
      payload &&
      payload.hasOwnProperty("version") &&
      payload.version == "v4"
    ) {
      return Api().post(
        `/api/admin/v4/getDailySalesRecordsConcessionReports`,
        payload
      );
    } else {
      return Api().post(
        `/api/admin/v2/getDailySalesRecordsConcessionReports`,
        payload
      );
    }
  },
  GetdailySalesAdvanceRecords(payload) {
    return Api().post(`/api/admin/v2/dailySalesAdvanceSales`, payload);
  },
  GetTodaysSalesAdvanceRecords(payload) {
    return Api().post(`/api/admin/v2/TodaysAdvanceSalesSummary`, payload);
  },
  getaddonsArray(payload) {
    return Api().post(`/api/admin/v2/getAddonsData`, payload);
  },
  getMaterializedReport(payload) {
    return Api_2().post(`/api/admin/v2/getmaterializedReport`, payload);
  },
  getSalesBookReport(payload) {
    return Api_2().post(`/api/admin/v2/getSalesBook`, payload);
  },
  getSalesReturnWithCancelReasonReport(payload) {
    return Api_2().post(
      `/api/admin/v2/getSalesReturnWithCancelReason`,
      payload
    );
  },
  getConcessionItemSales(payload) {
    return Api_2().post(`/api/admin/v2/getConcessionItemSales`, payload);
  },
  getDCRFinanceReport(payload) {
    return Api_2().post(`/api/admin/v2/getDcrFinanceReport`, payload);
  },
  getMonthDayWiseTracker(payload) {
    return Api().post(`/api/reports/month-day-wise-tracker`, payload);
  },
  getDistributorReportStar(payload) {
    return Api_2().post(`/api/admin/v2/distributorReportStar`, payload);
  },
  getDistributorMovieFormatV2(payload) {
    return Api().post(
      "/api/admin/v2/getDistributorsMoviesWithFormatV2",
      payload
    );
  },
  getMunicipalityReportDetail(payload) {
    return Api_2().post(`/api/admin/v2/getMuncipalityDetailReport`, payload);
  },
  getMunicipalityReportSummary(payload) {
    return Api_2().post(`/api/admin/v2/getMunicipalitySummaryReport`, payload);
  },
  getMaskewaariReport(payload) {
    return Api_2().post(`/api/admin/v2/getMaskewaariReport`, payload);
  },
  getProductSalesReport(payload) {
    return Api_2().post(`/api/admin/v2/getProductSalesReport`, payload);
  },
  getDailySalesAndCollectionStar(payload) {
    return Api_2().post(`/api/reports/daily-sales-collection-v3`, payload);
  },
  getDailySalesAndCollectionEpix(payload) {
    return Api_2().post(`/api/reports/getDailySalesCollectionEpix`, payload);
  },
  getDailySalesAndCollectionPlay(payload) {
    return Api_2().post(`/api/reports/getDailySalesCollectionPlay`, payload);
  },
  getFnbSummaryReport(payload) {
    return Api().post(`/api/admin/v2/getFnbSalesSummary`, payload);
  },
  getMTaxReport(payload) {
    return Api_2().post(`/api/reports/get-mtax-report`, payload);
  },
  salesBookFix(payload) {
    return Api().post(`/api/admin/v2/salesBookFix`, payload);
  },
  crmTransactions(payload) {
    return Api().post(`/api/crm-data/crmTransactions`, payload);
  },
  getPerformanceReportLebanon(payload) {
    return Api().post(`/api/admin/v2/performance-report-lebanon`, payload);
  },
  GetSummaryTransactionLog(payload) {
    return Api().post(`/api/reports/getSummaryTransactionLogs`, payload);
  },
  GetUserCashierSummary(payload) {
    return Api().post(`/api/reports/getUserCashierSummary`, payload);
  },
  GetHouseKeepingReportV2(payload) {
    return Api_2().post(`/api/reports/houseKeepingReportV3`, payload);
  },
  getLoyaltyOverView(payload) {
    return Api().post(`/api/admin/loyalty_overview_report`, payload);
  },
  getLoyaltySettlements(payload) {
    return Api().post(`/api/admin/loyalty_settlements_report`, payload);
  },
  GetManualBillCollection(payload) {
    return Api().post(`/api/admin/manual_bill/manual_bill_collection`, payload);
  },
  getDistributorShareSummaryData(payload) {
    return Api().post(`api/admin/v2/getDistributorShareSummaryData`, payload);
  },
  getDistributorShareSummaryWeekWiseData(payload) {
    return Api().post(
      `api/admin/v2/getDistributorShareSummaryWeekWiseData`,
      payload
    );
  },
  getScheduledMoviesDropDown(payload) {
    return Api().post("/api/admin/v2/scheduled-movie-list", payload);
  },
  getQFXDistributorCollectionReportV2(payload) {
    return Api().post(
      "/api/admin/v2/distributor-collection-report-qfx",
      payload
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/ReportsService-v2.js